var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    {
      staticClass: "fill-height"
    },
    [
      _c(
        "gg-card-text",
        [
          _c(
            "v-list",
            [
              _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _c("strong", [_vm._v("Status")])
                      ])
                    ],
                    1
                  ),
                  _c("v-list-item-action", [_vm._v(_vm._s(_vm.details.status))])
                ],
                1
              ),
              _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _c("strong", [_vm._v("Date Generated")])
                      ])
                    ],
                    1
                  ),
                  _c("v-list-item-action", [
                    _vm._v(_vm._s(_vm.details.date_generated))
                  ])
                ],
                1
              ),
              _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _c("strong", [_vm._v("Timeframe")])
                      ])
                    ],
                    1
                  ),
                  _c("v-list-item-action", [
                    _vm._v(
                      _vm._s(
                        _vm.details.timeframe_action ===
                          _vm.timeframeActions.CANCEL_NOW
                          ? "Cancel Now"
                          : "Do Not Renew"
                      )
                    )
                  ])
                ],
                1
              ),
              _vm.details.can_expedite
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c(
                            "v-list-item-title",
                            [
                              _vm.details.timeframe_action !==
                              _vm.timeframeActions.CANCEL_NOW
                                ? _c(
                                    "gg-btn",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        small: "",
                                        tile: "",
                                        color: "primary"
                                      },
                                      on: {
                                        click: function click($event) {
                                          return _vm.$emit("cancel-now")
                                        }
                                      }
                                    },
                                    [_vm._v(" Cancel Now ")]
                                  )
                                : _vm._e(),
                              _c(
                                "gg-btn",
                                {
                                  attrs: {
                                    small: "",
                                    color: "gray-dark"
                                  },
                                  on: {
                                    click: function click($event) {
                                      return _vm.$emit("autorenew-now")
                                    }
                                  }
                                },
                                [_vm._v(" I Changed My Mind ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.details.escalated
                ? [
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _c(
                                "strong",
                                {
                                  staticClass: "red--text text--lighten-1"
                                },
                                [_vm._v("Request Escalated")]
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _c("strong", [_vm._v("Offer")])
                            ])
                          ],
                          1
                        ),
                        _c("v-list-item-action", [
                          _vm._v(_vm._s(_vm.details.offer_name))
                        ])
                      ],
                      1
                    ),
                    _c(
                      "v-list-item",
                      [
                        _c(
                          "v-list-item-content",
                          [
                            _c("v-list-item-title", [
                              _c("strong", [_vm._v("Summary")])
                            ])
                          ],
                          1
                        ),
                        _c("v-list-item-action", [
                          _vm._v(_vm._s(_vm.details.offer_message))
                        ])
                      ],
                      1
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }